// extracted by mini-css-extract-plugin
module.exports = {"details":"ItemDetails-module__details___2KLaK","detail":"ItemDetails-module__detail___2wJFo"};